import React, { Suspense } from "react";

const HomePage = React.lazy(() => import("../view/vault.jsx"));

const Home = () => {
  return (
    <Suspense fallback={null}>
      <HomePage />
    </Suspense>
  );
};

export default Home;
